import React from 'react'
import { Box, SidePanel } from '@node-space/ui-components'
import { appBannersId } from 'components/app/AppBanners'
import { useComponentHeight } from 'hooks/useComponentHeight'
import { NestedCustomerStatusHighlight } from 'pages/Customers/components/CustomerHighlight'
import { CustomerDetailsHeader } from 'pages/Customers/CustomerDetails/CustomerDetailsHeader'
import { EmbeddedCustomerDetailsProps } from 'pages/EmbeddedCustomers/CustomerDetails/EmbeddedCustomerDetails'
import { CustomerStatus, CustomerStatusType } from 'types/customers'
import { highlightRowBasedOnId } from 'utils/table/table'
import { SidePanelCustomerBody } from './SidePanelCustomerBody'

export const NestedCustomerDetails = ({
  isOpen,
  onClose,
  pageCustomers,
  customerDetails,
}: EmbeddedCustomerDetailsProps) => {
  const bannerSpacing = useComponentHeight(appBannersId)

  return (
    <SidePanel
      id="side-panel-customer-list"
      isOpen={isOpen}
      onClose={onClose}
      paging={pageCustomers}
      activeRowId={customerDetails?.reference}
      onActiveRowChange={highlightRowBasedOnId}
      topOffset={bannerSpacing}
      header={
        <CustomerDetailsHeader
          name={customerDetails?.name}
          description={customerDetails?.description}
          {...(customerDetails?.status !== CustomerStatus.VERIFIED && {
            StatusHighlight: (
              <NestedCustomerStatusHighlight
                status={customerDetails?.status as CustomerStatusType}
              />
            ),
          })}
        />
      }
      body={
        <Box flex paddingX={4} flexCol gapY={4} width="full">
          <SidePanelCustomerBody customerId={customerDetails?.reference} />
        </Box>
      }
    />
  )
}
